export default "__VITE_ASSET__d7b23f4d__"